import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-300 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-12">
          <div className="max-w-sm">
            <a href="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg"></i>
              </div>
              <span className="font-heading text-xl font-semibold text-background-50">
                Superbuy Spread
              </span>
            </a>
            <p className="text-xs md:text-sm text-background-500 leading-relaxed">
              Your ultimate resource hub for discovering the best Superbuy spreadsheet finds.
              Curated categories, updated regularly, designed for smarter shopping.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-background-200 font-semibold text-sm mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <a href="/" className="text-xs text-background-500 hover:text-background-200 transition-colors">Home</a>
                <a href="/superbuy-spreadsheet-guide" className="text-xs text-background-500 hover:text-background-200 transition-colors">Complete Guide</a>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-background-200 transition-colors">Superbuy Sheet</a>
              </div>
            </div>
            <div>
              <h4 className="text-background-200 font-semibold text-sm mb-4">Categories</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-background-200 transition-colors">Shoes</a>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-background-200 transition-colors">Hoodies</a>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-background-200 transition-colors">Jackets</a>
                <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-background-200 transition-colors">Bags</a>
              </div>
            </div>
            <div>
              <h4 className="text-background-200 font-semibold text-sm mb-4">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <a href="/superbuy-spreadsheet-guide" className="text-xs text-background-500 hover:text-background-200 transition-colors">Complete Guide</a>
                <a href="/qc-guide" className="text-xs text-background-500 hover:text-background-200 transition-colors">QC Tips</a>
                <a href="/safety-guide" className="text-xs text-background-500 hover:text-background-200 transition-colors">Safety Guide</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-600">
            &copy; 2026 Superbuy Spread. All rights reserved.
          </p>
          <p className="text-xs text-background-700 italic">
            This website is an independent resource and is not officially affiliated with Superbuy.
          </p>
        </div>
      </div>
    </footer>
  );
}